module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "load-btn"
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "addHide",
    attrs: {
      "action": _vm.xxx,
      "headers": _vm.postHead,
      "before-upload": _vm.prevCtrls,
      "on-success": _vm.successCtrls,
      "file-list": _vm.imgfiles,
      "disabled": true,
      "list-type": "picture-card",
      "data": _vm.fileData,
      "on-remove": _vm.handleRemove,
      "limit": 1,
      "on-preview": _vm.handlePictureCardPreview,
      "on-exceed": _vm.handleExceed
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02987a58"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/upload/uploadSingleView.vue
// module id = 1677
// module chunks = 1